import React from "react";

import ClockIcon from "@uui/Clock";

import ProcessingBadge from "@app/analytics/components/Badges/ProcessingBadge";
import OwnerCell from "@app/analytics/MeetingReports/ReportsTable/cells/OwnerCell";
import SourceCell from "@app/analytics/MeetingReports/ReportsTable/cells/SourceCell";
import {
  ProcessingCell,
  ProcessingCellText,
  ProcessingTableRow,
} from "@app/analytics/MeetingReports/ReportsTable/styles";
import type { Topic } from "@app/analytics/types";

import { Row } from "@rui/Stack";

const TopicReportProcessingRow = ({
  report,
  withScore,
}: {
  report: Topic;
  withScore: boolean;
}) => (
  <ProcessingTableRow>
    <ProcessingCell>
      <SourceCell report={report} asCell={false} />
    </ProcessingCell>
    <ProcessingCell sx={{ maxWidth: "300px" }}>
      <Row variant="left" spacing={2}>
        <ProcessingCellText>{report.title}</ProcessingCellText>
        <ProcessingBadge />
      </Row>
    </ProcessingCell>
    <ProcessingCell>
      <Row variant="left" spacing={0.5}>
        <ClockIcon sx={{ fontSize: "12px", color: "shades.neutral.300" }} />
        <ProcessingCellText>Est. processing time: 1 hr</ProcessingCellText>
      </Row>
    </ProcessingCell>
    <ProcessingCell colSpan={withScore ? 2 : 1}>
      {/* Placeholder for (optional) Read Score and Tags column */}
    </ProcessingCell>
    <ProcessingCell>
      <OwnerCell owner={report.ownerName} asCell={false} />
    </ProcessingCell>
    <ProcessingCell>{/* Placeholder for actions column */}</ProcessingCell>
  </ProcessingTableRow>
);

export default TopicReportProcessingRow;
